import {MatDialogRef} from '@angular/material/dialog';

export abstract class AbstractAssessmentDialogComponent<T> {
  protected constructor(protected readonly _ref: MatDialogRef<T>) {
    this._ref.addPanelClass('custom-assessment-dialog');
  }
}
